import { makeStyles } from "@material-ui/styles"
import { black } from "chalk"

const styles = makeStyles(theme => ({
  popupIcon: {
    color: theme.palette.primary.main + "!important"
  },
  tagsInput: {
    width: "100%"
  },
  addButton: {
    marginLeft: theme.spacing(2)
  },
  tagContainer: {
    height: 300,
    overflow: "auto"
  },

  tagContent: {
    "&:first-child": {
      paddingTop: 0,
      paddingLeft: 0,
      paddingRight: 0,
      marginLeft: 0,
      marginRight: 0
    },
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap"
  },

  tag: {
    margin: theme.spacing(1, 1),
    marginLeft: 0,
    backgroundColor: "#ADB4FF"
  },

  removeButton: {
    color: theme.palette.warning.main + "!important"
  },
  deleteLoading: {
    marginRight: 10,
    marginLeft: -5
  },

  popupIndicator: {
    color: "black !important"
  },

  root: {
    width: "80%"
  },

  rootTag: {
    backgroundColor: "#ADB4FF"
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationEmail/ManageTagsDialog/UpdateEmail/styles.js